import makeStateFilter from '../../../make-state-filter';

import { stateFilter as parentStateFilter } from '../orders.reducer.metadata';

const namespace = 'ordersImport';
const stateFilter = makeStateFilter(parentStateFilter, namespace);

export { namespace, stateFilter };
